/* [ START OF MODULE - VER 1.2 (src/hooks/useIsMobile.js) ] */

import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../components/Roadmap/constants';

const MOBILE_BP = MOBILE_BREAKPOINT - 1;

let _mql = null;
const getMql = () => {
  if (typeof window === 'undefined') return null;
  if (!_mql) _mql = window.matchMedia(`(max-width: ${MOBILE_BP}px)`);
  return _mql;
};

// RMI-2026-379: pure UA/touch check, independent of useIsMobile()'s viewport-
// width logic. Any tablet under the 768px breakpoint (common in portrait)
// was previously classified "mobile" and routed to MobileShell, which has no
// Reports feature at all. App.jsx uses this to route tier-4+ tablet users to
// the desktop Command Center instead -- see App.jsx for why phones and
// low-tier field techs are deliberately left untouched.
export const isTabletDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad/.test(ua)) return true;
  // iPadOS 13+ Safari masquerades as desktop Macintosh but supports multi-touch.
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
  // Android phones include "Mobile" in the UA; Android tablets omit it.
  if (/Android/.test(ua) && !/Mobile/.test(ua)) return true;
  return false;
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    if (params.has('mobile')) return params.get('mobile') !== '0';
    const mql = getMql();
    return mql ? mql.matches : false;
  });

  useEffect(() => {
    const mql = getMql();
    if (!mql) return;
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
};

export default useIsMobile;

/*
===============================================================================
CHANGE MANIFEST
===============================================================================
VER 1.2 -- BUILD-2026.685 -- 2026-07-30 -- RMI-2026-379
- ADD: isTabletDevice() -- pure UA/touch check (iPad, iPadOS 13+ Macintosh
  masquerade, Android-without-"Mobile") used by App.jsx to route tier-4+
  tablet users to the desktop Command Center instead of the phone-oriented
  Mobile app, which had no Reports/Favorites feature at all. useIsMobile()
  itself is unchanged.
VER 1.1 -- BUILD-2026.453 -- 2026-06-16 -- matchMedia + mobile param
- BUGFIX: Replaced window.innerWidth with window.matchMedia for the initial
  state check. Mobile browsers (Chrome/Safari) can briefly report a wider
  viewport before the address bar collapses; matchMedia returns the correct
  CSS-pixel width synchronously, eliminating the brief desktop flash.
- FEATURE: ?mobile=1 URL param forces mobile view; ?mobile=0 forces desktop.
  This was documented in App.jsx comments but never implemented.
VER 1.0 -- BUILD-2026.283 -- 2026-05-25 -- Extraction from RoadmapPage.jsx
- New file. Threshold (MOBILE_BREAKPOINT=768) imported from
  src/components/Roadmap/constants.js.
===============================================================================
*/
/* [ END OF MODULE - VER 1.2 (src/hooks/useIsMobile.js) ] */
